import { createRoot } from "react-dom/client";
import App from "./app.jsx";
import AppLocalizationProvider from "util/localizationProvider";

import * as Sentry from "@sentry/react";

import "scss/main.scss";
import ServiceWorkerContextProvider from "Context/serviceWorker.tsx";

Sentry.init(
	(process.env.REACT_APP_SENTRY_ENV ?? process.env.NODE_ENV) === "development"
		? {
				dsn: "https://077bfacf2743d38b70be0e4648415c6e@o4511970680438784.ingest.de.sentry.io/4511970846703697",
				spotlight: true,
				sampleRate: 1.0,
				tracesSampleRate: 1.0,
				enableLogs: true,
				sendDefaultPii: true,
				environment: "development",
				release: "dev",
				integrations: [
					Sentry.consoleLoggingIntegration(),
					Sentry.browserTracingIntegration(),
					Sentry.spotlightBrowserIntegration(),
				],
				tracePropagationTargets: ["localhost"],
			}
		: {
				dsn: "https://da7e1164a26e780312fe60399c6e2436@o302617.ingest.sentry.io/4506076797534208",
				tracesSampleRate: process.env.REACT_APP_SENTRY_ENV === "experimental" ? 0.1 : 0,
				environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
				release: process.env.REACT_APP_SENTRY_RELEASE,
				sendDefaultPii: true,
				tracePropagationTargets: [
					"https://api.liveto.io",
					"https://api.staging.liveto.io",
					"https://api.experimental.liveto.io",
				],
			},
);

//const oppositeOrientation = screen.orientation.type.startsWith("portrait") ? "landscape" : "portrait";
//screen.orientation.lock("portrait")

// remove old logs if present - burden on localstorage
localStorage.removeItem("device-log");

const root = createRoot(document.getElementById("root"));
root.render(
	<ServiceWorkerContextProvider>
		<AppLocalizationProvider>
			<App />
		</AppLocalizationProvider>
	</ServiceWorkerContextProvider>,
);
